import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

/* =====================================================
   CART PROVIDER (PERSISTENT)
===================================================== */
export function CartProvider({ children }) {
  // ✅ Load from localStorage on first load
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem("cart");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  /* ---------------------------------
     Save to localStorage on change
  --------------------------------- */
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  /* ---------------------------------
     ADD TO CART (variant-safe)
  --------------------------------- */
const addToCart = (product, variant = null) => {
  setCart((prev) => {

    // ===============================
    // SHOP PRODUCT
    // ===============================
    if (product.type === "shop") {

      const key = `shop_${product.id}`;

      const existing = prev.find(item => item.key === key);

      if (existing) {
        return prev.map(item =>
          item.key === key
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }

      return [
        ...prev,
        {
          key,

          type: "shop",

          id: product.id,

          shopId: product.shopId,

          shopName: product.shopName,

          ownerUid: product.ownerUid,

          name: product.name,

          brand: product.brand,

          image: product.image,

          price: product.price,

          mrp: product.mrp,

          stock: product.stock,

          qty: 1,
        },
      ];
    }

    // ===============================
    // EYAL PRODUCT (existing logic)
    // ===============================

    const key = `${product.product_id}_${variant.variantId}`;

    const existing = prev.find(item => item.key === key);

    if (existing) {

      return prev.map(item =>
        item.key === key
          ? { ...item, qty: item.qty + 1 }
          : item
      );

    }

    return [
      ...prev,
      {
        key,

        type: "eyal",

        product_id: product.product_id,

        name: product.name,

        brand: product.brand,

        image: variant.image || product.image || product.image_url,

        variantId: variant.variantId,

        color: variant.color,

        size: variant.size,

        price: variant.price,

        qty: 1,
      },
    ];

  });
};


  /* ---------------------------------
     UPDATE QUANTITY
  --------------------------------- */
  const updateQty = (key, qty) => {
    setCart((prev) => {
      if (qty <= 0) {
        return prev.filter((item) => item.key !== key);
      }

      return prev.map((item) =>
        item.key === key ? { ...item, qty } : item
      );
    });
  };

  /* ---------------------------------
     REMOVE ITEM
  --------------------------------- */
  const removeItem = (key) => {
    setCart((prev) =>
      prev.filter((item) => item.key !== key)
    );
  };

  /* ---------------------------------
     CLEAR CART (after order)
  --------------------------------- */
  const clearCart = () => {
    setCart([]);
    localStorage.removeItem("cart");
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        updateQty,
        removeItem,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

/* =====================================================
   HOOK
===================================================== */
export function useCart() {
  return useContext(CartContext);
}
